import { Check, Clock, AlertTriangle } from 'lucide-react';
import { PALABRA_REVISION, TONO_REVISION } from './documentos';

// En qué estado está una revisión de un documento controlado.
// Palabra + color + icono: los tres, para que se entienda en una pantalla
// pequeña, impreso en blanco y negro, y por alguien que no distinga los
// colores.
export default function EtiquetaRevision({ estado }) {
  return (
    <span className={`inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full border ${TONO_REVISION[estado] || TONO_REVISION.OBSOLETA}`}>
      {estado === 'VIGENTE' ? <Check size={12} aria-hidden="true" /> : null}
      {estado === 'BORRADOR' ? <Clock size={12} aria-hidden="true" /> : null}
      {estado === 'OBSOLETA' ? <AlertTriangle size={12} aria-hidden="true" /> : null}
      {PALABRA_REVISION[estado] || estado}
    </span>
  );
}
